import { render, staticRenderFns } from "./x-file-button.vue?vue&type=template&id=275341be&scoped=true"
import script from "./x-file-button.vue?vue&type=script&lang=js"
export * from "./x-file-button.vue?vue&type=script&lang=js"
import style0 from "./x-file-button.vue?vue&type=style&index=0&id=275341be&prod&lang=css"
import style1 from "./x-file-button.vue?vue&type=style&index=1&id=275341be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275341be",
  null
  
)

export default component.exports